import m, { useRef as C, useEffect as M } from "react";
import y from "./otpInput.module.scss.js";
function _({
  length: e = 4,
  value: a,
  onChange: p,
  design: c,
  autoFocus: n = !0,
  disabled: D = !1
}) {
  const f = C([]);
  M(() => {
    var o;
    n && ((o = f.current[0]) == null || o.focus());
  }, [n]);
  const s = (o) => {
    var t;
    const r = Math.max(0, Math.min(e - 1, o));
    (t = f.current[r]) == null || t.focus();
  }, b = (o, r) => {
    const t = r.replace(/\D/g, "").slice(-1), l = a.split("");
    l[o] = t;
    const u = l.join("").slice(0, e);
    p(u.padEnd(e, "").slice(0, e).replace(/ /g, "")), t && o < e - 1 && s(o + 1);
  }, k = (o, r) => {
    if (r.key === "Backspace")
      if (a[o]) {
        const t = a.split("");
        t[o] = "", p(t.join(""));
      } else
        s(o - 1);
    else r.key === "ArrowLeft" ? (r.preventDefault(), s(o - 1)) : r.key === "ArrowRight" && (r.preventDefault(), s(o + 1));
  }, h = (o, r) => {
    r.preventDefault();
    const t = r.clipboardData.getData("text").replace(/\D/g, "").slice(0, e - o);
    if (!t) return;
    const l = a.split("");
    t.split("").forEach((E, A) => {
      l[o + A] = E;
    });
    const u = l.join("").slice(0, e);
    p(u);
    const w = Math.min(o + t.length, e - 1);
    s(w);
  }, i = {
    "--otp-text-color": c == null ? void 0 : c.textColor,
    "--otp-border-color": c == null ? void 0 : c.borderColor,
    "--otp-bg-color": c == null ? void 0 : c.backgroundColor,
    "--otp-focus-border-color": c == null ? void 0 : c.focusBorderColor
  };
  return /* @__PURE__ */ m.createElement("div", { className: y.wrapper, style: i }, Array.from({ length: e }, (o, r) => /* @__PURE__ */ m.createElement(
    "input",
    {
      key: r,
      ref: (t) => {
        f.current[r] = t;
      },
      className: y.input,
      type: "text",
      inputMode: "numeric",
      pattern: "[0-9]*",
      maxLength: 1,
      value: a[r] ?? "",
      disabled: D,
      onChange: (t) => b(r, t.target.value),
      onKeyDown: (t) => k(r, t),
      onPaste: (t) => h(r, t)
    }
  )));
}
export {
  _ as OtpInput
};
//# sourceMappingURL=OtpInput.js.map
